import { SINGAPORE_TRIPLE_POINT_CAMPAIGN_EARN_KEY } from 'loyalty/constants/loyaltyEarn'

/**
 * @dev temporary campaign for earn key for Singapore triple point campaign on accommodation LPP LPC
 */
function getLoyaltySgBonusCampaignEarnKey(
  propertyCountryCode: string | undefined,
  currentRegionCode: string,
): string | undefined {
  return propertyCountryCode === 'SG' && currentRegionCode === 'AU' ? SINGAPORE_TRIPLE_POINT_CAMPAIGN_EARN_KEY : undefined
}

export default getLoyaltySgBonusCampaignEarnKey
